import { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { MecanicaDeSuelos } from './pages/MecanicaDeSuelos';
import { ControlDeCalidad } from './pages/ControlDeCalidad';
import { IngenieriaEstructural } from './pages/IngenieriaEstructural';
import { SupervisionDeObra } from './pages/SupervisionDeObra';
import {Topografia} from './pages/Topografia'
import {Arquitectura} from './pages/Arquitectura'
import { LinkTree } from './pages/LinkTree';
import { LinkTree2 } from './pages/LinkTree2';
import { QRPage } from './pages/QRPage';
import { QRPage2 } from './pages/QRPage2';
import { EducaLIECPage } from './pages/EducaLIECPage';
import { initGA, trackPageView } from './lib/analytics';

function App() {
  const location = useLocation();

  // Initialize Google Analytics on mount
  useEffect(() => {
    initGA();
  }, []);

  // Track page views on route change
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/servicios/mecanica-de-suelos" element={<MecanicaDeSuelos />} />
      <Route path="/servicios/control-de-calidad" element={<ControlDeCalidad />} />
      <Route path="/servicios/ingenieria-estructural" element={<IngenieriaEstructural />} />
      <Route path="/servicios/supervision-de-obra" element={<SupervisionDeObra />} />
      <Route path="/servicios/supervision-de-obra" element={<SupervisionDeObra />} />
      <Route path="/servicios/topografia" element={<Topografia />} />
      <Route path="/servicios/arquitectura" element={<Arquitectura />} />
      <Route path="/educaliec" element={<EducaLIECPage />} />
      <Route path="/links" element={<LinkTree />} />
      <Route path="/links2" element={<LinkTree2 />} />
      <Route path="/admin/qr" element={<QRPage />} />
      <Route path="/admin/qr2" element={<QRPage2 />} />
    </Routes>
  );
}

export default App;
